export default "__VITE_ASSET__BgExlwvh__ 100w";